module.exports = __webpack_public_path__ + "img/AndroidTV_W800F.8a678baa.png";